module.exports = __webpack_public_path__ + "img/1-1-chat.a3176f58.svg";